// This file is part of React-Invenio-Deposit
// Copyright (C) 2021 CERN.
// Copyright (C) 2021 Northwestern University.
//
// React-Invenio-Deposit is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

export const CREATIBUTOR_TYPE = {
  PERSON: 'personal',
  ORGANIZATION: 'organizational',
};
